import {
  axios as request
} from "../../request/http";

const interfaceUrl = {
  "api_productSkuSpList": "/product/sku/spQueryList", // 查询资金商SKU列表
}

// initial state
const state = {
  productSkuSpList: [],
}

// getters
const getters = {
  getProductSkuSpList: state => {
    return state.productSkuSpList
  },
}

// actions
const actions = {
  getProductSkuSpList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSkuSpList,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('PRODUCT_SKU_SP_LIST', res || {});
      } else {
        commit('PRODUCT_SKU_SP_LIST', {});
      }
    }).catch(err => {
      commit('PRODUCT_SKU_SP_LIST', {});
    })
  },
}


// mutations
const mutations = {
  PRODUCT_SKU_SP_LIST: (state, pageData) => {
    state.productSkuSpList = pageData;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js